import Tooltip from "../ui-control/Tooltip";
import DemandStudioHeaderButton from "./DemandStudioHeaderButton";
import useDemandStudioPreviewDownloadButton from "../../hooks/useDemandStudioPreviewDownloadButton";
import useDemandStudioPreview from "../../hooks/useDemandStudioPreview";
import { useDemandStudioContext } from "../../contexts/DemandStudioContext";

const headerIconBtnClasses =
  "inline-flex items-center justify-center h-10 w-10 border border-border " +
  "rounded-full bg-white font-secondary text-base text-subtle cursor-pointer " +
  "transition-[border-color,color,background-color] duration-150 " +
  "hover:not-disabled:border-primary hover:not-disabled:text-primary " +
  "hover:not-disabled:bg-primary/[0.08] " +
  "disabled:cursor-not-allowed disabled:opacity-60";

const DemandStudioPreviewDownloadButton = () => {
  const {
    showPreview,
    caseDetails,
    caseId,
    forcedDemandType,
    forcedClientId
  } = useDemandStudioContext();
  
  const { tooltipTitle, icon, onClick, disabled } = useDemandStudioPreviewDownloadButton({
    isOpen: showPreview,
    docxFiles: caseDetails?.docxFiles,
    clients: caseDetails?.clients,
    caseId,
    usePreviewHook: useDemandStudioPreview,
    forcedDemandType,
    forcedClientId
  });

  return (
    <Tooltip title={tooltipTitle} placement="bottom" leaveDelay={50}>
      <DemandStudioHeaderButton
        icon={icon}
        label=""
        ariaLabel={tooltipTitle}
        onClick={onClick}
        disabled={disabled}
        className={headerIconBtnClasses}
      />
    </Tooltip>
  );
};

export default DemandStudioPreviewDownloadButton;
